import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import ResourcesSection from './components/ResourcesSection';
import PillarsSection from './components/PillarsSection';
import SafetySection from './components/SafetySection';
import FaqSection from './components/FaqSection';
import FinalCta from './components/FinalCta';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'USFansSheet.casa',
    url: siteUrl,
    description:
      'USFans Spreadsheet resource hub with original guides, product lists, categories, shipping tips and safety information.',
    inLanguage: ['en', 'pl', 'es', 'fr'],
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'USFansSheet.casa',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg',
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CategorySection />
        <AboutSection />
        <ResourcesSection />
        <PillarsSection />
        <SafetySection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
    </div>
  );
}